export const getUrlMovie = (thumb_url) => {
  return encodeURI(
    `https://ophim.cc/_next/image?url=https://img.ophim.tv/uploads/movies/${thumb_url}&w=160&q=75`
  );
};

export const getTimeCurrent = () => {
  const now = new Date();

  const h = now.getHours() >= 10 ? now.getHours() : `0${now.getHours()}`;
  const m = now.getMinutes() >= 10 ? now.getMinutes() : `0${now.getMinutes()}`;
  const s = now.getSeconds() >= 10 ? now.getSeconds() : `0${now.getSeconds()}`;

  return `${h}:${m}:${s}`;
};

export const encodeFixedLengthString = (input, length = 30) => {
  const paddedInput = input.padEnd(length, " ");

  return btoa(paddedInput);
};

export const decodeFixedLengthString = (encodedString) => {
  const decodedString = atob(encodedString);

  return decodedString.trim();
};

export const isMobile = (userAgent) => {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    )
  ) {
    return true;
  }

  return false;
};

export const filterObject = (obj, callback) => {
  const result = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && callback(obj[key], key)) {
      result[key] = obj[key];
    }
  }

  return result;
};
